<template>
<b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
  <div class="wrapper">
    <nav-bar />
      <step-1 :form="form" @componentFormSubmitted="fillComponentFormData" v-if="step == 1" :step="step" :sidebarListLinks="sidebarListLinks" :eventParentToChildComponentFrom="eventComponentForm" :workOrder="workOrder"></step-1>
      <step-2 :form="form" @componentFormSubmitted="fillComponentFormData" v-else-if="step == 2" :step="step" :sidebarListLinks="sidebarListLinks" :eventParentToChildComponentFrom="eventComponentForm" :workOrder="workOrder"></step-2>
      <step-3 :form="form" @componentFormSubmitted="fillComponentFormData" v-else-if="step == 3" :step="step" :sidebarListLinks="sidebarListLinks" :eventParentToChildComponentFrom="eventComponentForm" :workOrder="workOrder"
      @emitLoader="emitloader"
      ></step-3>
      <step-4 :form="form" @componentFormSubmitted="fillComponentFormData" v-else-if="step == 4" :step="step" :sidebarListLinks="sidebarListLinks" :eventParentToChildComponentFrom="eventComponentForm" :selectedContractor="selected_contractors_id" :workOrder="workOrder"></step-4>
      <footer-component></footer-component>

  </div>
  </b-overlay>
</template>

<script>
import NavBar from "../../includes/NavBar.vue";
import Step1 from "./Step1.vue";
import Step2 from "./Step2.vue";
import Step3 from "./Step3.vue";
import Step4 from "./Step4.vue";
import { Form } from "vform";
import _ from "lodash";
import moment from "moment";
import phoneNoMixin from "../../../../../mixins/phoneNoMixin.js";
import FooterComponent from "../../../../pages/includes/FooterComponent.vue";


export default {
  components: {
    NavBar,
    Step1,
    Step2,
    Step3,
    Step4,
    FooterComponent
  },
  props: {
    selected_contractors_id: [],
    workOrder: String
  },
  mixins: [phoneNoMixin],
  data() {
    return {
      loader: false,
      step: 1,
      eventComponentForm: new Vue(),
      sidebarListLinks: [
        { label: 'Job Type', routeTo: this.workOrder ? { name: 'manager-workorder-edit', params: { step: 1 } } :  { name: 'manager-quote-edit', params: { step: 1 } }, disabled: true },
        { label: 'Key Dates', routeTo:  this.workOrder ? { name: 'manager-workorder-edit', params: { step: 2 } } : { name: 'manager-quote-edit', params: { step: 2 } }, disabled: true },
        { label: 'Details', routeTo: this.workOrder ? { name: 'manager-workorder-edit', params: { step: 3 } } : { name: 'manager-quote-edit', params: { step: 3 } }, disabled: true },
        { label: 'Invite', routeTo: this.workOrder ? { name: 'manager-workorder-edit', params: { step: 4 } } :  { name: 'manager-quote-edit', params: { step: 4 } }, disabled: true },
      ],
      id: null,

      form: new Form({
        edit_start_timestamp: "",
        type: this.workOrder ? this.workOrder : 'quote',
        id: "",
        validate_only: "",
        validate_step: "",
        save_draft: "",

        // step 1
        form_type: "",
        strata_plan_id: null,
        address_note: "",
        is_private: 1,
        strata_plan: [],
        strataDefaultOption: [],

        //step 2
        issue_date: "",
        due_date: "",
        completion_date: "",
        priority: "medium",
        min_estimate_budget: "",
        formattedMinEstimateBudget: "",
        max_estimate_budget: "",
        formattedMaxEstimateBudget: "",
        recurring: "off",
        recursion_quote: [
          {
            id: null,
            day: null,
            month: null,
            month_date: null,
            recurring_period: "daily",
          },
        ],
        recurring_end_date: "",

        //step 3
        trader_type: [],
        job_title: "",
        description: "",
        site_contact_name: "",
        site_access_contact: "",
        site_access_email: "",
        reply_to_email: this.$store.state.authenticatedUserData.user.id,
        total_quotes_required: this.workOrder ? "1":"3",
        attachements: [],
        site_photos: [],
        storage_filename: [],
        formattedSiteContactPhone: "",

        //step 4
        selected_contractor_id: [],
        contractors: []
      }),
    };
  },
  mounted() {
    if (this.$route.params.id != "new") {
      this.id = this.$route.params.id;
      this.fetchFormData(this.$route.params.id);

    } else {
      this.form.issue_date = moment().format('DD-MM-YYYY');
      this.updateSidebarDisabledLinks();
    }

    this.step = this.$route.params.step;
    this.form.edit_start_timestamp = Math.floor((new Date()).getTime() / 1000);
  },
  methods: {
    fillComponentFormData(stepData, stepFrom, isSkipped = 0) {
      _.forEach(stepData, (value, key) => {
        this.form[key] = value;
      });

      // if user clicks skip on component form we receive isSkipped as 1
      // is_draft is same as isSkipped on this.submitFormData()
      this.submitFormData(stepFrom, 1, isSkipped);
    },

    fetchFormData(id) {
      axios.post("api/manager/quote/getDetails",{
        id: id,
        load_strata_plan: 1,
        load_invitations: 1,
        load_categories_id: 1,
        load_invitations_user_id: 1
      }).then((response) => {

          this.form.fill(response.data.quote);

          response.data.quote.is_work_order ? this.form.type = 'work-order' : this.form.type = 'quote'

          //Declaring timestamp or overwriting after fetching data.
          this.form.edit_start_timestamp = Math.floor((new Date()).getTime() / 1000);

          //Turning Recurring on of there is recurring quote
          if(this.form.recursion_quote.length > 0){
            this.form.recurring = 'on';
            this.form.recurring_end_date = moment(this.form.recursion_quote[0]['end_date']).format('DD-MM-YYYY');
          }

          //Managing FIle
          this.form.attachements = [];
            _.forEach(response.data.quote.attachments, (value,key) => {
              let extension = value.file_name.split('.').pop();
                this.form.attachements.push({
                      extension: extension,
                      file_name:  value.file_name,
                      name: value.name,
                      temporary_path: 'empty',
                      uuid: value.uuid
                });
            });

          //Managing pphotos
          this.form.site_photos = [];
          _.forEach(response.data.quote.site_photos, (value,key) => {
            let extension = value.file_name.split('.').pop();
              this.form.site_photos.push({
                    extension: extension,
                    file_name:  value.file_name,
                    name: value.name,
                    temporary_path: 'empty',
                    uuid: value.uuid
                });
          });

          //For managing date formt on child event fire
          this.form.issue_date = moment(this.form.issue_date).format('YYYY-MM-DD');
            if (this.form.due_date) {
                this.form.due_date = moment(this.form.due_date).format('YYYY-MM-DD');
            }
          if (this.form.completion_date) {
              this.form.completion_date = moment(this.form.completion_date).format('YYYY-MM-DD');
          }

          //For max and min budget format
          this.minEstimateBudgetFormat();
          this.maxEstimateBudgetFormat();

             //For formating manger phone number
          this.formatPhone(response.data.quote.site_contact);

          //Fire event to component form data
          this.eventComponentForm.$emit('event-parent-child-componentform', {data: this.form});
          this.updateSidebarDisabledLinks();
      });
    },

    submitFormData(stepFrom, validate_only = 0, save_draft = 1) {
      this.$root.$data.bsLoader = true;
      this.form.validate_step = stepFrom;
      this.form.validate_only = stepFrom < 4 ? validate_only : 0;
      this.form.save_draft = save_draft;

      this.loader = true;
      this.form.post("api/manager/quote/updateOrCreate",{
        workOrder: this.workOrder
        }).then((response) => {
        this.$root.$data.bsLoader = false;
        this.loader = false;
        if (validate_only && stepFrom < 4) {
          this.form.id = response.data.quote.id;

          if(this.workOrder){
            this.$router.push({
              name: "manager-workorder-edit",
              params: { step: stepFrom + 1, id: response.data.quote.id },
              query: {selected_contractors_id : this.selected_contractors_id}
            }).catch((err) => {
              this.$root.$data.bsLoader = false;
            });
          }else{
            this.$router.push({
              name: "manager-quote-edit",
              params: { step: stepFrom + 1, id: response.data.quote.id },
              query: {selected_contractors_id : this.selected_contractors_id}
            }).catch((err) => {
                this.$root.$data.bsLoader = false;
              });
          }
        } else {
         this.workOrder ? this.$router.push({ name: "manager-workorder" }) : this.$router.push({ name: "manager-quotes" });
        }
      });
    },
    updateSidebarDisabledLinks(){
      let maxAllowedRouteStep = 1;

      if(this.form.due_date){
        maxAllowedRouteStep = 2;
      }
      if(this.form.trader_type.length > 0){
        maxAllowedRouteStep = 3;
      }
      if(this.form.selected_contractor_id.length > 0){

        maxAllowedRouteStep = 4;
      }
      _.each(this.sidebarListLinks, (sidebarListLink, idx) => {
        if(maxAllowedRouteStep >  idx){
          sidebarListLink.disabled = false;
        }
      })
    },
    minEstimateBudgetFormat(){
      this.form.formattedMinEstimateBudget = this.form.min_estimate_budget?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    maxEstimateBudgetFormat(){
        this.form.formattedMaxEstimateBudget = this.form.max_estimate_budget?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
   formatPhone(site_access_contact) {
      this.form.site_access_contact = site_access_contact ? this.getPhoneDigitsOnly(site_access_contact) : null;
      this.form.formattedSiteContactPhone =  this.form.site_access_contact ? this.formatPhoneForAustralia(this.form.site_access_contact) : null;
    },
    emitloader(get_loader_value){
      this.loader = get_loader_value;
    },
  },
   watch: {
    $route($to, $from) {
      if ($to.name == "manager-quote-edit") {
        this.step = $to.params.step;
        this.type = "quote";
        this.updateSidebarDisabledLinks();
      }
      if ($to.name == "manager-workorder-edit") {
        this.step = $to.params.step;
         this.type = "work-order";
        this.updateSidebarDisabledLinks();
      }
    },
  },
};
</script>
